module.exports = __webpack_public_path__ + "img/chouette.55a5a86a.svg";